import Vue from 'vue'
import Vuex from 'vuex'
// 测试
import test from '@/store/modules/test.js'

import commonStore from "@/store/modules/commonStore/index" 
Vue.use(Vuex)

let base = '' 
// 图片视频相关
const debugCode = 2
if (debugCode === 0) {
  base = 'https://demo.gkgzj.com'
} else if (debugCode === 1) {
  base = 'https://test.gkgzj.com'
} else if (debugCode === 2) {
  base = 'https://dygk.gkgzj.com'
}

export default new Vuex.Store({
  state: {
    loading: false,
    // 登录需要的token
    token: 'Basic ZGV5YV9pbnRyb2R1Y3Rpb25faDU6QWExMjM0NTY3OGFB',
    // 登录后需要的token
    access_token: localStorage.getItem('access_token'),
    // 图片下载的地址
    downloadPath: base + '/incontrol-fileserver/file/download/',
    // 文件下载相关
    downloadpath: base + '/incontrol-fileserver/file/download/',
    downloadpic: base + '/incontrol-fileserver/file/pic/filterImg/',
    // 文件base
    _base: base,
    header: {
      // headers:{"x-domain":"","x-userkey":""}bc40ec6b2dd84f668efd312d54a060db
      headers: {
        "x-domain": "A0",
        "x-userkey": ""
      }
    },
  },
  mutations: {
    showLoading (state) {
      console.log('stateTrue....')
      state.loading = true
    },
    hideLoading (state) {
      state.loading = false
    },
    vModelAccessToken (state, data = {}) {
      state.access_token = data.access_token
      localStorage.setItem('access_token', data.access_token)
    }
  },
  actions: {
    // 获取登录token
    getAccessToken ({ commit }) {
      return new Promise((resolve, reject) => {
        const params = {
          grant_type: 'client_credentials'
        }
        // 获取token
        Vue.prototype.$http.token(params)
          .then(res => {
            commit('vModelAccessToken', res)
            resolve(res) // 返回新的token数据,http.js中使用
          })
          .catch(err => {
            console.log('token刷新失败:', err)
            reject(err)
          })
      })
    }
  },
  modules: {
    test,
    commonStore
  }
})
